import { useSelector } from "react-redux";
import { FloatPanel } from "../../../../../components/floatPanel";
import { CategoryEditor } from "./reference";
import "../../catalogs/edition/reference.css";
import "./reference.css";
export const Edition = () => {
  const panel=useSelector(state=>state.aplicationConfig.userConfig.floatPanel);
  return <FloatPanel className="catalogReferencePanel categoryReferencePanel" template={<CategoryEditor key={`${panel.queryId}-${panel.isEmpty}`}/>}/>;
};
